<template>
  <div class="sku-info-header__wrapper">
    <div class="sku-base-info__wrapper">
      <div class="sku-img__wrapper">
        <div>
          <el-image
            :src="
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg'
            "
            :preview-src-list="[
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg',
            ]"
          >
            <div slot="error" class="image-slot">
              <img src="/image/static/img/nopic-square.jpg" />
            </div>
          </el-image>
        </div>
      </div>
      <div class="info__wrapper">
        <el-descriptions
          class="border-detail-main-form"
          border
          size="small"
          :column="2"
        >
          <el-descriptions-item
            :label="'SkuNo'"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '240px' }"
          >
            {{ formData.amzSkuNo || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.Status') || '状态'"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '139px' }"
          >
            <b-badge
              style="font-size: 12px"
              :variant="
                formData.amzSkuStatus === 'Y'
                  ? 'success'
                  : formData.amzSkuStatus === 'D'
                  ? 'danger'
                  : 'primary'
              "
            >
              {{ formData.v_amzSkuStatus }}
            </b-badge>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          border
          class="border-detail-main-form"
          size="small"
          :column="2"
        >
          <el-descriptions-item
            :labelStyle="{ minWidth: '100px', maxWidth: '100px' }"
            :contentStyle="{ maxWidth: '479px', minWidth: '479px' }"
            :label="$l('form_label_goodsName') || '产品名称'"
          >
            {{ formData.goodsName || '' }}
            <br />
            {{ formData.goodsNameEn || '' }}
          </el-descriptions-item>
        </el-descriptions>

        <el-descriptions
          border
          size="small"
          class="border-detail-main-form"
          :column="2"
        >
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '240px' }"
            :label="$l('INDEX.table_label_category') || '分类'"
          >
            {{ formData.categoryFullName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '139px' }"
            :label="$l('INDEX.VC') || 'VC产品'"
          >
            <el-tag
              v-if="formData.isVc"
              size="mini"
              effect="dark"
              :type="formData.isVc == 'Y' ? 'warning' : ''"
            >
              {{ formData.v_isVc }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions border size="small" :column="2">
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '240px' }"
            :label="$l('INDEX.form_label_brand') || '品牌'"
          >
            {{ formData.brandName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '139px' }"
            :label="$l('INDEX.form_label_succession') || '系列'"
          >
            {{ formData.collectionName || '' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="div_title mt-3">
      {{ this.$l('tab_pane_label_skuImage') || '产品图片' }}
    </div>
    <SkuImage
      class="mb-4"
      ref="skuImage"
      :disabled="disabled"
      :amzSkuCode="amzSkuCode"
      @getData="getData"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import SkuImage from '../aws-sku-product-images'
export default {
  mixins: [EditLoading],
  components: { SkuImage },
  props: {
    disabled: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
    baseInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {},
    }
  },
  watch: {},
  computed: {
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
  },
  methods: {
    async getData() {
      if (!this.amzSkuCode) return
      const res = await this.$api
        .ecomAmzSkuDetailApi({
          amzSkuCode: this.amzSkuCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
  },
}
</script>
<style lang="scss" scoped>
.sku-info-header__wrapper {
  background-color: white;
  overflow: hidden;
  .sku-base-info__wrapper {
    display: flex;
    align-items: stretch;

    .info__wrapper {
      flex: 1;
      height: auto;
    }
    .sku-img__wrapper {
      width: 131px;
      border: 1px solid #e8e8e8;
      border-right: 0px;
      display: flex;
      justify-content: center;
      align-items: self-start;
      .el-image {
        margin-top: 9px;
        width: 100px;
        height: 100px;
      }
    }
  }
}

.div_title {
  color: #2b3447;
  font-size: 16px;
  font-weight: 600;
}

::v-deep {
  .el-descriptions--small.is-bordered .el-descriptions-item__cell {
    padding: 10px 10px !important;
  }
  .border-detail-main-form {
    .el-descriptions-item__cell {
      border-bottom: 0px !important;
    }
  }
}

::v-deep {
  .images-container {
    height: 100%;
  }
}
</style>
